import { BackButtonEvent } from '@ionic/core';
import { AnimationBuilder, NavContext, NavContextState } from '@ionic/react';
import { ReactElement, useEffect } from 'react';

interface HardwareBackButtonListenerProps {
  defaultHref?: string;
  routerAnimation?: AnimationBuilder;
  priority: number;
  disableBackButton?: boolean;
}

interface HardwareBackButtonInternalListenerProps
  extends HardwareBackButtonListenerProps {
  context: NavContextState;
}

const HardwareBackButtonInternalListener = (
  props: HardwareBackButtonInternalListenerProps
) => {
  useEffect(() => {
    const listener = (event: BackButtonEvent) => {
      event.detail.register(props.priority, () => {
        event.stopPropagation();
        if (!props.disableBackButton) {
          if (props.context.hasIonicRouter()) {
            props.context.goBack(props.defaultHref, props.routerAnimation);
          } else if (props.defaultHref !== undefined) {
            window.location.href = props.defaultHref;
          }
        }
      });
    };

    document.addEventListener(
      'ionBackButton',
      listener as EventListenerOrEventListenerObject
    );

    return () => {
      document.removeEventListener(
        'ionBackButton',
        listener as EventListenerOrEventListenerObject
      );
    };
  }, [
    props.context,
    props.defaultHref,
    props.priority,
    props.disableBackButton,
    props.routerAnimation,
  ]);

  return null;
};

const HardwareBackButtonListener = (
  props: HardwareBackButtonListenerProps
): ReactElement => {
  return (
    <NavContext.Consumer>
      {(context) => {
        return (
          <HardwareBackButtonInternalListener
            defaultHref={props.defaultHref}
            routerAnimation={props.routerAnimation}
            priority={props.priority}
            disableBackButton={props.disableBackButton}
            context={context}
          />
        );
      }}
    </NavContext.Consumer>
  );
};

export { HardwareBackButtonListener };
